// extracted by mini-css-extract-plugin
export var cardHeader = "_fx-1";
export var contentCard = "_fx-0";
export var headerActions = "_fx-3";
export var reorderHandle = "_fx-5";
export var titleArea = "_fx-2";
export var titleAreaWithHandle = "_fx-4";